import { Close } from '@mui/icons-material';
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import { memo, PropsWithChildren, ReactElement, ReactNode } from 'react';

export interface DetailViewToolbarProps extends PropsWithChildren {
  onClose: () => void;
  title?: string;
  adornment?: ReactNode;
}

export const DetailTitlebar = memo(function ({
  children,
  onClose,
  title,
  adornment,
}: DetailViewToolbarProps): ReactElement {
  return (
    <>
      <Stack direction='row' alignItems='center' width='100%' justifyContent={'space-between'} spacing={2}>
        <IconButton size='large' edge='start' color='primary' aria-label='closeOverlay' onClick={onClose}>
          <Close />
        </IconButton>
        <Box display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap={1}>
          <Typography variant='h6' color='black' flex={1} textAlign='center'>
            {title}
          </Typography>
          {adornment}
        </Box>
        {children}
      </Stack>
      <Divider variant='middle' />
    </>
  );
});
